"use client";
import "../chunk-GOCCUU3Z.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { CpslIcon } from "@getpara/react-components";
const BannerContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: transparent;
`;
const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: ${({ $maxWidth }) => $maxWidth || "100%"};
  box-sizing: border-box;
  padding: 6px;
  border-radius: 12px;
  background-color: transparent;
  position: relative;
  z-index: 10;
  display: inline-flex;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const WarningIcon = styled(CpslIcon)`
  --icon-color: #fbbc04;
  --width: ${({ $size }) => $size || "24px"};
  --height: ${({ $size }) => $size || "24px"};
  margin-right: 6px;
  flex-shrink: 0;
`;
const BannerText = styled.span`
  font-family: var(--cpsl-default-font);
  font-weight: 500;
  font-size: ${({ $fontSize }) => $fontSize || "14px"};
  color: var(--cpsl-color-black);
  flex: 1;
`;
const NetworkSpeedBanner = ({
  fontSize,
  iconSize,
  maxWidth
}) => {
  const [isSlowNetwork, setIsSlowNetwork] = useState(false);
  useEffect(() => {
    var _a;
    const connection = navigator == null ? void 0 : navigator.connection;
    const checkNetworkSpeed = () => {
      if (connection) {
        const isSlow = connection.effectiveType === "2g" || connection.effectiveType === "slow-2g" || connection.downlink && connection.downlink < 0.5;
        setIsSlowNetwork(isSlow);
      } else {
        setIsSlowNetwork(false);
      }
    };
    checkNetworkSpeed();
    (_a = connection == null ? void 0 : connection.addEventListener) == null ? void 0 : _a.call(connection, "change", checkNetworkSpeed);
    const intervalId = setInterval(checkNetworkSpeed, 15e3);
    return () => {
      var _a2;
      clearInterval(intervalId);
      (_a2 = connection == null ? void 0 : connection.removeEventListener) == null ? void 0 : _a2.call(connection, "change", checkNetworkSpeed);
    };
  }, []);
  if (!isSlowNetwork) {
    return null;
  }
  return /* @__PURE__ */ jsx(BannerContainerWrapper, { children: /* @__PURE__ */ jsxs(BannerContainer, { $maxWidth: maxWidth, children: [
    /* @__PURE__ */ jsx(WarningIcon, { $size: iconSize, icon: "alertTriangle" }),
    /* @__PURE__ */ jsx(BannerText, { $fontSize: fontSize, children: "Your network is slow. This may impact your experience." })
  ] }) });
};
export {
  NetworkSpeedBanner
};
